"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["colorOne", "colorTwo"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Card = function Card(_ref) {
  var colorOne = _ref.colorOne,
    colorTwo = _ref.colorTwo,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {
        one: {},
        two: {}
      };
      if (colorOne) {
        style.one.fill = (0, _selectors.getColor)(uiTheme, colorOne);
      }
      if (colorTwo) {
        style.two.fill = (0, _selectors.getColor)(uiTheme, colorTwo);
      }
      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        id: "shadow",
        style: style.two,
        fillRule: "nonzero",
        d: "M11.8800356,8.93062523 C11.8745598,8.95796029 11.8694027,8.98543782 11.8645689,9.0130546 L8.40362256,28.7864496 C8.08505125,30.6065403 9.29142416,32.3421813 11.0981319,32.6631125 L23.7535404,34.9111319 C23.1748687,35.4044311 22.4264121,35.7018672 21.6089965,35.7018672 L8.32179932,35.7018672 C6.48722021,35.7018672 5,34.2036304 5,32.3554619 L5,12.2770305 C5,10.4288619 6.48722021,8.93062523 8.32179932,8.93062523 L11.8800356,8.93062523 Z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        id: "card",
        style: style.one,
        fillRule: "nonzero",
        transform: "translate(22.113439, 19.163399) rotate(10.000000) translate(-22.113439, -19.163399)",
        d: "M13.2317627,5.76951866 L30.967005,5.7919796 C31.5734338,5.79274762 32.0648484,6.28416655 32.0656111,6.89059527 L32.096507,31.4558961 C32.0972711,32.0634088 31.6054041,32.5565146 30.9978913,32.5572787 C30.9969658,32.5572799 30.9960403,32.5572799 30.9951148,32.5572787 L13.2598724,32.5348177 C12.6534437,32.5340497 12.162029,32.0426308 12.1612663,31.4362021 L12.1303704,6.87090127 C12.1296063,6.26338852 12.6214733,5.77028272 13.2289861,5.76951865 C13.2299116,5.76951748 13.2308371,5.76951749 13.2317627,5.76951866 Z"
      }));
    }
  }));
};
Card.defaultProps = {
  colorOne: null,
  colorTwo: null
};
var _default = exports["default"] = Card;
var name = exports.name = 'Card';
var availableProps = exports.availableProps = ['colorOne', 'colorTwo'];